import axios from "axios";

// Resolved at runtime (not baked in at build time) so a stale/misconfigured
// REACT_APP_BACKEND_URL can never point a real deployment at localhost:
// any hostname other than localhost always calls the API on its own origin.
function resolveApiBase() {
  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";
  if (!isLocalHost) return "/api";
  return `${process.env.REACT_APP_BACKEND_URL || "http://localhost:2015"}/api`;
}

export const API_BASE = resolveApiBase();

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});
